'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPregnantWoman = function MdPregnantWoman(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 21.6v6.8h-5v8.2h-5v-8.2h-3.2v-11.8c0-2.7 2.2-5 5-5s5 2.3 5 5c1.9 0.8 3.2 2.8 3.2 5z m-11.6-15c0-1.8 1.5-3.2 3.4-3.2s3.2 1.4 3.2 3.2-1.4 3.4-3.2 3.4-3.4-1.5-3.4-3.4z' })
        )
    );
};

exports.default = MdPregnantWoman;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/pregnant-woman.js
// module id = 3436
// module chunks = 0